module.exports = __webpack_public_path__ + "static/media/DFYN.3488cef9.png";